import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PowerSearchViewResponse } from '../Models/power-search-view-response.model';
import { Question } from '../Models/power-search-view-response.model';
import { SearchResultsResponse } from '../Models/search-results-response';
import { SmartSearchRequest } from '../Models/smart-search-request.model';
@Injectable({
  providedIn: 'root'
})
export class PowerSearchApiService {

  private urlPowerSearchQuestions = '/TgNewUI/Search/Ajax/PowerSearch';

  private urlPowerSearchJobs = '/TgNewUI/Search/Ajax/PowerSearchJobs';

  constructor(private http: HttpClient) { }

  getPowerSearchQuestions(partnerId: number, siteId: number): Observable<PowerSearchViewResponse> {
    const request = { partnerId, siteId };
    return this.http.post<PowerSearchViewResponse>(this.urlPowerSearchQuestions, request);
  }
  getPowerSearchJobs(req: SmartSearchRequest,RFT:string): Observable<any> {
    const headers = {
      'RFT': RFT || ''
    };

    return this.http.post<any>(
      this.urlPowerSearchJobs,
      req, { headers }
        );
  }
}
